/**
 * DealsByStageRows.tsx — the "Deals by stage" rows, shared by Sales Dashboard
 * and Reports (§24 C-6 / C-7; the model is funnelRows.ts). Rows are real
 * <button>s that drill to the stage's deal list (SB-12 / R7-1..6); resting
 * classes are the ones both pages carried, so the pixel deltas are the ruled
 * ones only: the open tracks now scale to the OPEN max, and the Closed Won
 * row has left the track — no bar, its count with the qualifier in the
 * success ink (mono, the k-metric-delta idiom for a figure with words).
 */
import { funnelRows, type FunnelCount } from './funnelRows'

export function DealsByStageRows({ funnel, onDrill }: {
  /** The server's fixed 5-row spine (open stages + closed_won, zero-filled). */
  funnel: FunnelCount[]
  /** A row's stage, label and count, for the caller's stage drill. */
  onDrill: (row: { stage: string; label: string; count: number }) => void
}) {
  return (
    <div className="p-4 flex flex-col gap-3">
      {funnelRows(funnel).map(r => (
        <button key={r.stage} type="button" data-stage={r.stage}
          onClick={() => onDrill({ stage: r.stage, label: r.label, count: r.count })}
          className="flex items-center gap-3 w-full text-left cursor-pointer rounded-control hover:bg-surface-nav-hover focus:outline-none">
          <div className="w-24 flex-shrink-0 text-12 text-ink-secondary">{r.label}</div>
          {r.kind === 'open' ? (
            <>
              <div className="flex-1 h-2 rounded-full bg-surface-control overflow-hidden" data-track>
                <div className="h-full rounded-full" style={{ width: `${r.widthPct}%`, background: r.fill }} />
              </div>
              <div className="w-8 flex-shrink-0 text-right text-13 font-semibold text-ink-primary">{r.count}</div>
            </>
          ) : (
            <div className="flex-1 text-right text-12 font-mono" style={{ color: r.ink }}>{r.qualifier}</div>
          )}
        </button>
      ))}
    </div>
  )
}
